import SeoHead from '../../components/SeoHead';

export default function PoliticaPrivacidadPage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="Política de Privacidad – BN ĀGENZIA"
        description="Política de privacidad de BN ĀGENZIA. Información sobre el tratamiento de datos personales, finalidad, derechos del usuario y responsable del tratamiento."
        canonical="/politica-privacidad"
      />
      {/* Header */}
      <header className="bg-[#1A2B4A] py-6">
        <div className="max-w-4xl mx-auto px-8">
          <a href="/inicio" className="inline-flex items-center text-white hover:text-gray-200 transition-colors cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>
            Volver al inicio
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-8 py-16">
        <h1 className="text-4xl font-bold text-[#1A2B4A] mb-8">Política de Privacidad</h1>
        
        <div className="prose prose-lg max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">Responsable del tratamiento</h2>
            <ul className="space-y-2 text-gray-700">
              <li><strong>Nombre:</strong> Natalia Araque Do Nascimento</li>
              <li><strong>DNI:</strong> 46276489Y</li>
              <li><strong>Domicilio:</strong> Puerto de Sagunto, Valencia, España</li>
              <li><strong>Email:</strong> <a href="mailto:info@bnagenzia.com" className="text-[#1A2B4A] hover:underline">info@bnagenzia.com</a></li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">Finalidad del tratamiento</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Los datos personales recogidos a través del sitio web serán utilizados para:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Gestionar solicitudes de información.</li>
              <li>Gestionar registros de candidatos y empresas.</li>
              <li>Facilitar procesos de intermediación laboral.</li>
              <li>Mantener comunicación profesional relacionada con los servicios ofrecidos.</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              No se utilizarán los datos para fines distintos a los indicados.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">Legitimación</h2>
            <p className="text-gray-700 leading-relaxed">
              La base legal para el tratamiento de los datos es el consentimiento expreso del usuario al marcar la casilla correspondiente de aceptación de la Política de Privacidad.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">Conservación de los datos</h2>
            <p className="text-gray-700 leading-relaxed">
              Los datos se conservarán mientras exista interés mutuo en mantener la finalidad del tratamiento o hasta que el usuario solicite su supresión.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">Destinatarios</h2>
            <p className="text-gray-700 leading-relaxed">
              No se cederán datos a terceros salvo obligación legal o cuando sea necesario para la gestión de procesos de selección, en cuyo caso se informará previamente al interesado.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-[#1A2B4A] mb-4">Derechos del usuario</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              El usuario podrá ejercer los siguientes derechos:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Acceso</li>
              <li>Rectificación</li>
              <li>Supresión</li>
              <li>Limitación del tratamiento</li>
              <li>Oposición</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Para ejercer estos derechos deberá enviar una solicitud a: <a href="mailto:info@bnagenzia.com" className="text-[#1A2B4A] hover:underline">info@bnagenzia.com</a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#F8F6F3] py-8 mt-16">
        <div className="max-w-4xl mx-auto px-8 text-center">
          <p className="text-sm text-gray-600">© 2025 BN ĀGENZIA. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
}